export const CASH_REGISTER_EMPLOYEE_ENDPOINT =
  '/hospital-portal/api/employees/with-access-codes';

export const SECURITY_CODE_PATTERN = /^[a-zA-Z0-9]{4,8}$/;
